/**
 * Route definitions for the Customers module.
 * Lazily loads page components for customers list, customer details, and customer view (v2).
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const CustomersRoutes = createFeatureRoutes(
  'customers',
  {
    list: () => import('../presentation/pages/CustomersPage'),
    details: () => import('../presentation/pages/CustomerDetails'),
    view: () => import('../v2/pages/CustomerViewPage')
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'create', pageKey: 'details' },
    { path: ':id/view', pageKey: 'view' },
    { path: ':id', pageKey: 'details' }
  ]
);

export default CustomersRoutes;
